import { HorizontalLogo } from "../../atoms/logos/HorizontalLogo"

export const MobileHeader = ({ children }: { children: React.ReactNode }) => {
  return (
    <div className="mb-8 mt-6 flex items-center justify-between">
      <HorizontalLogo className="h-6" />
      {children}
    </div>
  )
}
